/* Rquiere de mixin.js */

var consignment = {
	data () {
		return {
			dateFromConsignments: '2020-07-15',
			dateToConsignments: '2020-07-18',
			listConsignments: [],
			methodsConsignment: {
				create: 'consignment/register',
				delete: '/delete',
				get: 'consignments',
				show: 'consignment/'
			},
			objectConsignment: {
				exists: 0,
				id: 0,
				description: '',
				total: 0,
				team_id: 0,
				team: {},
				status_id: 0,
				status: {},
				created_at: '',
				updated_at: ''
			},
			qRowsConsignment: 25,
			paginationConsignments: [],
			searchConsignments: '',
		}
	},
	computed: {
	},
	filters: {
	},
	methods:{
        addListConsignments(newConsignment) {
            this.listConsignments.unshift(newConsignment)
            if(this.listConsignments.length > this.qRowsConsignment) {
                this.listConsignments.splice(this.qRowsConsignment, 1)
            }
        },
		addListConsignmentsPayment(id, data) {
			let index = this.listConsignments.map((el) => parseInt(el.id)).indexOf(parseInt(id))
			if(index > -1) {
				this.listConsignments[index].payments.push(data.payment)
			}
		},
		deleteItemListConsignment(id) {
			let index = this.listConsignments.map((el) => parseInt(el.id)).indexOf(parseInt(id))
			let consignmentDeleted = this.listConsignments.splice(index,1)
		},
		deleteItemListConsignmentPayment(id, paymentId) {
			let index = this.listConsignments.map((el) => parseInt(el.id)).indexOf(parseInt(id))
			if(index > -1) {
				let ind = this.listConsignments[index].payments.map((el) => parseInt(el.id)).indexOf(parseInt(paymentId))
				let consignmentPaymentDeleted = this.listConsignments[index].payments.splice(ind,1)
			}
		},
		deleteConsignment(id) {
			this.$emit('showLockScreen', 'Borrando Remesa . . .')
			this.axiosActionIS(this.apiBackend + this.methodsConsignment.show + id + this.methodsConsignment.delete, 'DELETE', 'deleteConsignmentResult')
		},
		deleteConsignmentResult(response) {
			if(response.data.success === true) {
				this.deleteItemListConsignment(response.data.data)
				this.socketEmit(['DELETE_CONSIGNMENT'], response.data.data)
			}
			this.deleteConsignmentResultLocal(response)
		},
		deleteConsignmentResultLocal(response) {
			console.log('deleteConsignmentResultLocal no desarrollado', response)
		},
        changeQRowsConsignment() {
            localStorage.setItem('qRowsConsignment', this.qRowsConsignment)
			this.changeQRowsConsignmentLocal()
        },
		changeQRowsConsignmentLocal() {
			console.log('changeQRowsConsignmentLocal no desarrollado')
		},
		clearObjectConsignment() {
			this.objectConsignment.exists = 0
			this.objectConsignment.id = 0
			this.objectConsignment.description = ''
			this.objectConsignment.total = 0
			this.objectConsignment.team_id = 0
			this.objectConsignment.team = {}
			this.objectConsignment.status_id = 0
			this.objectConsignment.status = {}
			this.objectConsignment.created_at = null
			this.objectConsignment.updated_at = null
		},
		getAllConsignments(page = 1) {
			let parameters = '?search=' + this.searchConsignments + '&page=' + page + '&qRow=' + this.qRowsConsignment + '&fromDate=' + this.dateFromConsignments + '&toDate=' + this.dateToConsignments
            this.$emit('showLockScreen', 'Obteniendo lista de Remesas . . .')
			let url = this.apiBackend + this.methodsConsignment.get + parameters
			this.axiosActionIS(url, 'GET', 'getAllConsignmentsResult')
        },
		getAllConsignmentsByUserClient(page = 1){
			let parameters = '?search=' + this.searchConsignments + '&page=' + page + '&qRow=' + this.qRowsConsignment + '&fromDate=' + this.dateFromConsignments + '&toDate=' + this.dateToConsignments
            this.$emit('showLockScreen', 'Obteniendo lista de Remesas . . .')
			let url = this.apiBackend + this.methodsConsignment.get + '/byUserClient' + parameters
			this.axiosActionIS(url, 'GET', 'getAllConsignmentsResult')
        },
		getAllConsignmentsByTeam(page, teamId) {
			this.listConsignments = []
			let url = this.apiBackend + 'team/' + teamId + '/consignments?' + 'page=' + page
			this.axiosActionIS(url, 'GET', 'getAllConsignmentsResult')
		},
		getAllConsignmentsResult(response) {
			if(response.data.success === true) {
				this.listConsignments = response.data.data
				this.paginationConsignments = response.data.paginate
			}
			this.getAllConsignmentsResultLocal(response)
		},
		getAllConsignmentsResultLocal(response) {
			console.log('getAllConsignmentsResultLocal no desrrollado', response)
		},
		saveConsignment() {
			let method = (this.objectConsignment.exists == 0) ? 'POST' : 'PUT'
			this.$emit('showLockScreen', 'Guardando datos . . .')
			if(method == 'POST') {
				this.axiosActionIS(this.apiBackend + this.methodsConsignment.create, method, 'saveConsignmentResult', this.objectConsignment)
			} else {
				this.axiosActionIS(this.apiBackend + this.methodsConsignment.show + this.objectConsignment.id, method, 'saveConsignmentResult', this.objectConsignment)
            }
		},
		saveConsignmentResult(response) {
			if(response.data.success === true) {
                if(response.data.message == 'NEW') {
                    this.$snotify.success('Remesa creada con el código ' + response.data.data.id, 'Nueva Campaña')
                    this.addListConsignments(response.data.data)
                    //this.socketEmit(['NEW_CONSIGNMENT'], response.data.data)
                } else if(response.data.message == 'UPDATED') {
                    this.$snotify.info('Se ha actualizado la Remesa ' + response.data.data.name + ' con exito!!!', 'Actualizado')
                    this.socketEmit(['UPDATE_CONSIGNMENT'], response.data.data)
					this.updateListConsignment(response.data.data)
                }
				this.setObjectConsignment(response.data.data)
			}
			this.saveConsignmentResultLocal(response)		
		},
		saveConsignmentResultLocal(response) {
			console.log('saveConsignmentResultLocal no desarrollado', response)
		},
		setListeningConsignment() {
			this.sockets.subscribe('DELETE_CONSIGNMENT', (data) => { this.deleteItemListConsignment(data.body) })
			this.sockets.subscribe('NEW_CONSIGNMENT', (data) => { this.addListConsignments(data.body) })
			this.sockets.subscribe('UPDATE_CONSIGNMENT', (data) => { this.updateListConsignment(data.body) })
		},
		setObjectConsignment(item) {
			let newItem = Object.create(item)
			for (const property in newItem) {
				this.objectConsignment[property] = newItem[property]
			}
		},
		setConsignmentInit() {
			this.qRowsConsignment = (localStorage.getItem('qRowsConsignment') === null) ? this.qRowsConsignment : localStorage.getItem('qRowsConsignment')
			this.dateFromConsignments = this.currentDate(-180)
			this.dateToConsignments = this.currentDate()
			this.setListeningConsignment()
			this.setConsignmentInitLocal()
		},
		showConsignment(id, action = 'view') {
            let param = '?action=' + action
			this.axiosActionIS(this.apiBackend + this.methodsConsignment.show + id + param, 'GET', 'showConsignmentResult', null)
		},
		showConsignmentResult(response) {
			if(response.data.success === true) {
				this.setObjectConsignment(response.data.data)
			}
			this.showConsignmentResultLocal(response)
		},
		showConsignmentResultLocal(response) {
			console.log('showConsignmentResultLocal no desarrollado', response)
		},
		sumConsignmentPayment(payments) {
			let total = payments.reduce(function(a, b) { 
							let c = parseInt(b.amount)
							return a + parseInt(c)
						}, 0);
			return total.toFixed(0)
		},
		updateListConsignment(item) {
			let index = this.listConsignments.map((el) => parseInt(el.id)).indexOf(parseInt(item.id))
			if(index > -1) {
				let newItem = Object.create(item)
				for (const property in newItem) {
					this.listConsignments[index][property] = newItem[property]
				}
			}
		}
	},
};

export default consignment;